export enum NutrientUnit {
    percent = '%',
    g = 'g',
    gkg = 'g/kg'
}